import { render } from "./BackButton.vue?vue&type=template&id=48658531&scoped=true"
import script from "./BackButton.vue?vue&type=script&lang=js"
export * from "./BackButton.vue?vue&type=script&lang=js"

import "./BackButton.vue?vue&type=style&index=0&id=48658531&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48658531"]])

export default __exports__